<template>
  <div :class="['Login-Container', isMobile]">
    <h1 class="title">{{ $t('auth.login.welcome') }}</h1>
    <h2 class="subtitle">{{ $t('auth.login.subWelcome') }}</h2>

    <form class="login_form" @submit.prevent="signInUser" v-on:keyup.enter="signInUser"
 >
      <vv-form-text-input
        :testId="$cypress.anonymous.login.username"
        label="username"
        id="username"
        v-model="username"
        :validate="'required|email'"
        type="email"
      />

      <vv-form-text-input
        :testId="$cypress.anonymous.login.password"
        label="password"
        id="password"
        type="password"
        v-model="password"
        :validate="'required'"

      />

      <validate-form-button
        v-cypress="$cypress.anonymous.login.button"
        @click="signInUser"
        :isLoading="isLoading"
        :label="'forms.loginCta'"
      />

      <span class="ForgotPassword-Text" @click="$router.push('reset-password')">
        {{ $t('forms.forgotPasswordCta') }}
      </span>

    </form>

    <span class="Register-Text">{{ $t('auth.login.registerIntro') }}</span>
    <validate-form-button
      v-cypress="$cypress.anonymous.login.create_account"
      :class="['ValidateFormButton-Bis', isMobile]"
      @click="$router.push('Register')"
      :isLoading="false"
      :label="'auth.login.registerCta'"
    />
  </div>
</template>

<script>
import ValidateFormButton from '@/components/common/forms/vinovibes/ValidateFormButton'
import VvFormTextInput from '@/components/common/forms/vinovibes/VvFormTextInput'
import { SIGNIN_USER } from '@/store/modules/user/types'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'
import userMixin from '@/mixins/user'

export default {
  name: 'Login',
  components: {
    VvFormTextInput,
    ValidateFormButton
  },
  mixins: [userMixin],
  data: () => ({
    username: '',
    password: '',
    isLoading: false,
    error: '',
    redirect: null
  }),
  computed: {
    isMobile() {
      return this.$mq == 'desktop' ? '' : 'container-mobile'
    }
  },
  methods: {
    async signInUser() {
      this.error = ''

      if (this.username === '' || this.password === '') {
        this.$eventBus.$emit(SNACKBAR_MESSAGE, {
          message: this.$t('errors.custom/missing-credentials')
        })
        return
      }

      this.isLoading = true
      const [error] = await this.$store.dispatch(SIGNIN_USER, {
        username: this.username,
        password: this.password
      })

      if (error) {
        this.isLoading = false

        if (error.code) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code) })
        } else {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.custom/internal-error')
          })
        }
      }

      // let isLoading to true until app.vue catchup the firebase user
      // and set the user logged in store
    }
  },
  mounted() {
    if (this.isUserLogged) {
      return this.$router.push({ name: 'home' })
    }
    this.redirect = this.$route.query && this.$route.query.redirect ? this.$route.query.redirect : null
  },
  watch: {
    '$store.state.user.userLogged': function(userLogged) {
      if (userLogged) {
        if (this.redirect) this.$router.push({ path: this.redirect })
        else this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';

.Login-Container {
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-items: center;
  position: relative;
  left: -30px;
  padding-bottom: 100px;

  @include for-size(phone-only) {
    width: 80%;
  }

  &.container-mobile {
    left: 0;
  }

  .title {
    font-size: 60px;
    color: $primary;
    font-weight: 700;
    margin-bottom: 0;
    letter-spacing: -2px;
    text-align: center;

    @include for-size(phone-only) {
      font-size: 2rem;
    }
  }

  .subtitle {
    margin-top: 0;
    margin-bottom: 50px;
    font-family: Caveat;
    color: black;
    font-size: 30px;
    text-align: center;

    @include for-size(phone-only) {
      font-size: 1.5rem;
    }
  }
}

.FormText {
  height: 32px;
  border-radius: 5px;
  background-color: #f6f6f6;
  display: block;
  padding-bottom: 8px;
  width: 70%;
  margin-bottom: 14px;
}

.ForgotPassword-Text {
  display: block;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: black;
  text-decoration: underline;
  margin-top: 30px;

  @include for-size(phone-only) {
    font-size: 12px;
  }

  &:hover {
    cursor: pointer;
  }
}

.Register-Text {
  display: block;
  margin-top: 40px;
  margin-bottom: 14px;
  width: 65%;
  font-size: 24px;
  font-weight: 500;
  text-align: center;

  @include for-size(phone-only) {
    font-size: 1rem;
  }
}

form {
  background-color: $primary-alt;
  width: 60%;
  padding: 60px 50px 60px 50px;
  border-radius: 30px;

  @include for-size(phone-only) {
    width: 80%;
    padding: 20px 10px 20px 10px;
  }
}

</style>
